import type { ButtonHTMLAttributes } from 'react';
import { useI18n } from '../../i18n';

type FilterToggleProps = {
	isOpen: boolean;
	onToggle: () => void;
	activeCount?: number;
	label?: string;
	buttonProps?: ButtonHTMLAttributes<HTMLButtonElement>;
};

export default function FilterToggle({
	isOpen,
	onToggle,
	activeCount = 0,
	label = 'Filters',
	buttonProps
}: FilterToggleProps) {
	const { language } = useI18n();
	const copy = (en: string, de: string, hr: string) =>
		language === 'de' ? de : language === 'hr' ? hr : en;
	const { className: customClassName = '', ...restButtonProps } = buttonProps ?? {};
	const mergedClassName = ['btn btn-outline-secondary d-flex align-items-center gap-2', customClassName]
		.filter(Boolean)
		.join(' ');

	return (
		<button
			type="button"
			className={mergedClassName}
			onClick={onToggle}
			aria-expanded={isOpen}
			aria-pressed={isOpen}
			{...restButtonProps}
		>
			<i className="bi bi-sliders" aria-hidden="true" />
			<span>{label === 'Filters' ? copy('Filters', 'Filter', 'Filteri') : label}</span>
			{activeCount > 0 && (
				<span className="badge text-bg-success">{activeCount}</span>
			)}
			<i className={`bi bi-chevron-${isOpen ? 'up' : 'down'} ms-1`} aria-hidden="true" />
		</button>
	);
}

